import { IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import EditIcon from "./svgIcon/EditIcon";

const CustomEditLinkIcon = ({ ...props }) => {
  return (
    <Tooltip title={props?.label || "Edit"} placement="left" arrow>
      {props?.status == 0 ? (
        <IconButton>
          <EditIcon {...props} color="gray" />
        </IconButton>
      ) : (
        <Link to={props.to}>
          <IconButton>
            <EditIcon {...props} />
          </IconButton>
        </Link>
      )}
    </Tooltip>
  );
};

export default CustomEditLinkIcon;
